import React, {useRef, useState} from 'react';
import {useAddSilence} from "api/api-hooks/alert-fan-hooks";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import CalendarWrapper from "../../basic/calendar-wrapper/CalendarWrapper";
import {addToDate, ChronoUnitLegacy} from "utils/time-utils";
import {InputText} from "primereact/inputtext";
import useCurrentUser from "hooks/useCurrentUser";
import {InputTextarea} from "primereact/inputtextarea";
import {Chips} from "primereact/chips";
import {SilenceRequestDTO} from "@energy-advice/alertfan-api-client/dist/lib/generated/api";
import {Toast} from "primereact/toast";

type SilenceCreateProps = {
    showExpired: boolean
    tags?: { topics?: Array<string>, items?: Array<string> },

    dialog: boolean,
    showDialog: (val: boolean) => void,
}

const SilenceCreate = ({dialog, showDialog, showExpired, tags}: SilenceCreateProps) => {
    const toast = useRef<Toast | null>(null);

    const [itemTagChips, setItemTagChips] = useState<Array<string>>(tags?.items||[])
    const [topicTagChips, setTopicTagChips] = useState<Array<string>>(tags?.topics||[])
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(addToDate(new Date(), 1, ChronoUnitLegacy.DAYS))
    const [comment, setComment] = useState("")

    const {currentUser} = useCurrentUser();

    const {mutate} = useAddSilence(showExpired, {
        onSuccess: () => {
            showDialog(false)
            toast.current!!.show({severity: "success", summary: "Success", detail: "Silence was created", life: 3000});
        },
        onFailure: (err) => {
            toast.current!!.show({severity: "error", summary: "Error", detail: err, life: 3000});
        }
    })

    const onSilenceCreateButtonClick = () => {
        const tempSilenceRule: SilenceRequestDTO = {
            itemTags: itemTagChips,
            topicTags: topicTagChips,
            startsAt: dateFrom.toISOString(),
            endsAt: dateTo.toISOString(),
            createdBy: currentUser?.username || "unknown",
            comment: comment
        }

        mutate(tempSilenceRule)
    }

    return <>
        <Toast ref={toast}/>
        <Dialog onHide={() => showDialog(false)}
                visible={dialog} header={"Add Silence"}
                style={{width: "450px"}}
                resizable={false}>
            <div className={"flex flex-column gap-2"}>
                <div className={"flex flex-column"}>
                    <b>Item Tags</b>
                    <div className={"p-fluid"}>
                        <Chips value={itemTagChips} onChange={(e) => setItemTagChips(e.value)} addOnBlur/>
                    </div>
                </div>
                <div className={"flex flex-column"}>
                    <b>Topic Tags</b>
                    <div className={"p-fluid"}>
                        <Chips value={topicTagChips} onChange={(e) => setTopicTagChips(e.value)} addOnBlur/>
                    </div>
                </div>
                <div className={"flex gap-2"}>
                    <div className={"flex flex-column"}>
                        <b>Starts At</b>
                        <CalendarWrapper value={dateFrom} onChange={setDateFrom}/>
                    </div>
                    <div className={"flex flex-column"}>
                        <b>Ends At</b>
                        <CalendarWrapper value={dateTo} onChange={setDateTo}/>
                    </div>
                </div>
                <div className={"flex flex-column"}>
                    <b>Author</b>
                    <InputText value={currentUser?.username} disabled/>
                </div>
                <div className={"flex flex-column"}>
                    <b>Comment</b>
                    <InputTextarea rows={3} cols={30}
                                   value={comment}
                                   onChange={(e) => setComment(e.target.value)}
                                   autoResize
                    />
                </div>
                <Button label={"Create"} onClick={() => onSilenceCreateButtonClick()}/>
            </div>
        </Dialog>
    </>;
};

export default SilenceCreate;